import { Bell, Bug, History, Link2, Lock, Moon, ShieldCheck, User } from 'lucide-react';
export const SETTINGS_SECTIONS = [
    {
        id: 'profile',
        label: 'Profile',
        icon: User
    },
    {
        id: 'notifications',
        label: 'Notifications',
        icon: Bell
    },
    {
        id: 'history',
        label: 'History',
        icon: History
    },
    // Tenant sign-in configuration: admin, internal, or the IT Admin role.
    {
        id: 'sso',
        label: 'Single Sign-On',
        icon: Lock,
        access: 'signIn'
    },
    {
        id: 'authorization',
        label: 'Authorization Policies',
        icon: ShieldCheck,
        access: 'admin'
    },
    {
        id: 'appearance',
        label: 'Appearance',
        icon: Moon
    },
    {
        id: 'sharepoint',
        label: 'SharePoint',
        icon: Link2
    },
    // 'users' moved to the unified /admin console (polish task 04); the
    // ?section=users deep link still redirects there from Settings.tsx.
    {
        id: 'bug-reports',
        label: 'Bug Reports',
        icon: Bug
    }
];
/** Reports whether a viewer with these areas may open the section. */ export function canSeeSection(section, areas) {
    const def = SETTINGS_SECTIONS.find((s)=>s.id === section);
    switch(def?.access){
        case 'signIn':
            return areas.canManageSignIn;
        case 'admin':
            return areas.isAdmin;
        default:
            return true;
    }
}
export const TIMEZONE_OPTIONS = [
    {
        value: 'America/New_York',
        label: 'Eastern Time'
    },
    {
        value: 'America/Chicago',
        label: 'Central Time'
    },
    {
        value: 'America/Denver',
        label: 'Mountain Time'
    },
    {
        value: 'America/Los_Angeles',
        label: 'Pacific Time'
    },
    {
        value: 'UTC',
        label: 'UTC'
    }
];
